<template>

        <div id="birthday-modal">
            <div class="header clearfix">
                <div class="float-right cross" @click="tryAgain()">
                    <img src="~@/assets/images/ic-cancel.svg" alt="">
                </div>
            </div>
            <div class="body">
                <h2 class="text-center " style="color: red">{{ $t('errors.date_error') }}</h2>
                <div class="actions">
                    <button class="btn btn-primary" @click="tryAgain()">{{ $t('buttons.try_again') }}</button>
                    <button class="cancel-btn" @click="moveToRegularRegister">{{ $t('buttons.go_to_registration') }}</button>
                </div>

            </div>
        </div>



</template>

<script>
    export default {
        name: "BirthdayModal",
        methods: {
            moveToRegularRegister() {
                this.$router.push({name: 'registration.regular'})
            },
            tryAgain() {
                this.$emit('tryAgain')
            }
        }
    }
</script>

<style scoped>
    #birthday-modal {
        z-index: 9999;
        position: absolute;
        width: 500px;
        height: 309px;
        top: 25%;
        left: calc(50% - 250px);
        padding: 10px 25px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(10, 71, 102, 0.05);
        border-radius: 4px;
    }
    #birthday-modal .header{
        height: 50px;
        padding-top: 0;
    }
    #birthday-modal .cancel-btn {
        width: 100%;
        border-radius: 5px;
        background-color: transparent;
        font-size: 18px;
        font-family: "ProximaNovaBold", sans-serif;
        color: #0a4766;
        margin-bottom: 20px;
        transition: .2s ease background-color;
        border: 1.5px solid #03A9F4;
        line-height: 1.5;
        vertical-align: middle;
    }
    #birthday-modal .cross{
        margin: 10px;
    }
    #birthday-modal .body .actions{
        width: 70%;
        margin: 0 auto;
    }

    .overlay {
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #000;
        filter:progid:DXImageTransform.Microsoft.Alpha(opacity=55);
        opacity: 0.55;
    }
    * html .overlay {
        position: absolute;
        height: expression(document.body.scrollHeight > document.body.offsetHeight ? document.body.scrollHeight : document.body.offsetHeight + "px");
    }
</style>
